// import React, { useState, useRef, useEffect } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";
// import { FaBars } from "react-icons/fa";
// import html2canvas from "html2canvas";
// import "../App.css";

// drilldown(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,

//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const sortSubcategories = (categoryData) =>
//   Object.fromEntries(Object.entries(categoryData).sort());

// Object.keys(manualData).forEach((category) => {
//   manualData[category] = sortSubcategories(manualData[category]);
// });

// const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];
// const homeNetwork = "Anthem Participating Network";

// const DrilldownChart = () => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const chartContainerRef = useRef(null);

//   const toggleDropdown = () => {
//     setDropdownOpen((prev) => {
//       return !prev;
//     });
//   };
//   const handleFullScreen = () => {
//     if (chartContainerRef.current) {
//       if (document.fullscreenElement) {
//         document.exitFullscreen();
//       } else {
//         chartContainerRef.current.requestFullscreen().catch((err) => {
//           console.error("Error attempting fullscreen:", err);
//         });
//       }
//     }
//   };

//   const captureScreenshot = async () => {
//     setDropdownOpen(false);

//     const buttonElement = document.getElementById("capture-hide");
//     if (buttonElement) {
//       buttonElement.style.visibility = "hidden";
//     }

//     await new Promise((resolve) => setTimeout(resolve, 50));

//     if (chartContainerRef.current) {
//       await document.fonts.load('1em "Roboto Flex, serif !important"');
//       const canvas = await html2canvas(chartContainerRef.current, {
//         useCORS: true,
//         scale: 2,
//         backgroundColor: "#FFFFFF",

//         onclone: (clonedDoc) => {
//           clonedDoc.body.style.fontFamily = "'Roboto Flex', serif !important";
//         },
//       });

//       const image = canvas.toDataURL("image/png");
//       const link = document.createElement("a");
//       link.href = image;
//       link.download = "graph.png";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }

//     if (buttonElement) {
//       buttonElement.style.visibility = "visible";
//     }
//   };
//   useEffect(() => {
//     const checkFontLoaded = () => {
//       if (document.fonts && document.fonts.ready) {
//         document.fonts.ready.then(() => {
//           // You can now safely capture the screenshot
//         });
//       }
//     };

//     window.onload = checkFontLoaded;

//     return () => {
//       window.onload = null;
//     };
//   }, []);

//   useEffect(() => {
//     const onFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener("fullscreenchange", onFullScreenChange);
//     return () =>
//       document.removeEventListener("fullscreenchange", onFullScreenChange);
//   }, []);

//   const [isDrilldown, setIsDrilldown] = useState(true);
//   const [selectedCategory, setSelectedCategory] =
//     useState("Category III Codes");

//   const getChartOptions = (category, isDrilldownChart = true) => {
//     const categoryData = manualData[category];
//     const networks = [
//       ...new Set(
//         Object.values(categoryData).flatMap((prices) => Object.keys(prices))
//       ),
//     ];

//     const chartData = Object.entries(categoryData).map(([subcat, prices]) => ({
//       name: subcat,
//       y: typeof prices[homeNetwork] === "number" ? prices[homeNetwork] : null,
//       drilldown: subcat,
//       color: colorPalette[0],
//     }));

//     const drilldownSeries = Object.entries(categoryData).map(
//       ([subcat, prices]) => ({
//         name: subcat,
//         id: subcat,
//         data: networks.map((net, i) => [
//           net,
//           typeof prices[net] === "number" ? prices[net] : null,
//         ]),
//         colors: networks.map((net, i) =>
//           net === homeNetwork
//             ? colorPalette[0]
//             : colorPalette[(i + 1) % colorPalette.length]
//         ),
//       })
//     );

//     return {
//       chart: {
//         type: "column",
//         events: {
//           load() {
//             const chart = this;

//             if (!chart.customChip) {
//               chart.customChip = chart.renderer
//                 .label(
//                   "Drill to Network Comparison",
//                   chart.chartWidth - 230,
//                   0,
//                   "rect",
//                   40,

//                   40,
//                   true
//                 )
//                 .attr({
//                   fill: "#f0f0f0", // background color
//                   padding: 10,
//                   r: 4, // border radius
//                   zIndex: 10,
//                   width: 160,
//                   stroke: "#ccc", // border color
//                   "stroke-width": 0.5, // border thickness
//                   display: "flex", // flexbox for centering
//                   justifyContent: "center",
//                   alignItems: "center",
//                 })
//                 .css({
//                   color: "#333",
//                   fontSize: "12px",
//                   fontFamily: "'Roboto Flex', sans-serif",
//                   textAlign: "center",
//                   fontWeight: "500",
//                 })
//                 .add();
//             }
//           },
//           drilldown() {
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 text: "Drill to Subcategory",
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//           drillup() {
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 text: "Drill to Network Comparison",
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//           redraw() {
//             // Reposition chip on resize
//             const chart = this;
//             if (chart.customChip) {
//               chart.customChip.attr({
//                 x: chart.chartWidth - 230,
//                 y: 0,
//               });
//             }
//           },
//         },
//       },
//       title: {
//         text: category,
//       },
//       xAxis: {
//         type: "category",
//         style: {
//           fontSize: "12px",
//           fontWeight: "light",
//           fontFamily: "'Roboto Flex', serif !important",
//         },
//       },
//       yAxis: {
//         title: {
//           text: "% of Medicare",
//           style: {
//             // color: "#555555",
//             fontSize: "12px",
//             fontFamily: "'Roboto Flex', serif !important",
//             letterSpacing: "-0.75px",
//           },
//         },
//       },
//       legend: {
//         enabled: false,
//       },
//       credits: {
//         enabled: false,
//       },
//       plotOptions: {
//         series: {
//           states: {
//             hover: {
//               brightness: -0.4, // darken
//             },
//           },
//           borderWidth: 0,
//           dataLabels: {
//             enabled: true,
//             format: "{point.y:.2f}",
//             style: {
//               color: "#555555",
//               cursor: "pointer",
//               border: "none",
//               fontWeight: 500,
//               fontSize: "12px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//           },
//         },
//       },
//       exporting: { enabled: false },
//       tooltip: {
//         headerFormat:
//           '<span style="font-size: 14px; color: #5A5A5A; max-width: 250px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
//           '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//         pointFormat:
//           "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between' ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex; justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
//         shared: true,
//         backgroundColor: "rgba(255, 255, 255, 1)",
//         borderColor: "#A9A9A9",
//         borderRadius: 7,
//         animation: false,
//         hideDelay: 0,
//         style: {
//           color: "#333",
//           fontFamily: "'Roboto Flex', serif",
//           transition: "none",
//           fontSize: "12px",
//           padding: "8px",
//           shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//           zIndex: 99999,
//         },
//         shadow: true,
//         useHTML: true,
//         outside: true,
//       },

//       series: [
//         {
//           name: category,
//           colorByPoint: true,
//           data: chartData,
//         },
//       ],
//       drilldown: isDrilldownChart
//         ? {
//             series: drilldownSeries.map((series) => ({
//               ...series,
//               data: series.data.map(([net, value], i) => ({
//                 name: net,
//                 y: value,
//                 color: series.colors[i],
//               })),
//               // 👇 Add this block here to disable hover effect on drilldown
//               states: {
//                 hover: {
//                   enabled: false,
//                   brightness: 0,
//                 },
//               },
//             })),

//             activeAxisLabelStyle: {
//               color: "#555555",
//               cursor: "pointer",
//               fontWeight: "normal",
//               fontSize: "11px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//             activeDataLabelStyle: {
//               color: "#555555",
//               cursor: "pointer",
//               border: "none",
//               fontWeight: 500,
//               fontSize: "12px",
//               fontFamily: "'Roboto Flex', serif !important",
//               textDecoration: "none",
//             },
//             breadcrumbs: {
//               position: {
//                 align: "left",
//                 fontFamily: "'Roboto Flex', serif !important",
//               },
//               buttonTheme: {
//                 fill: "#fff",
//                 stroke: "#ccc",
//                 style: {
//                   color: "#333",
//                 },
//               },
//             },
//           }
//         : {},
//     };
//   };

//   const [chartOptions, setChartOptions] = useState(
//     getChartOptions(selectedCategory)
//   );

//   return (
//     <div
//       className="bg-white p-4"
//       style={{ border: "none", borderRadius: "8px" }}
//     >
//       {/* <select
// className="mb-4 p-2 border rounded"
// value={selectedCategory}
// onChange={(e) => {
// setIsDrilldown((prev) => !prev);
// setSelectedCategory(e.target.value);
// setChartOptions(getChartOptions(e.target.value));
// }}
// >
// {Object.keys(manualData).map((cat) => (
// <option key={cat} value={cat}>
// {cat}
// </option>
// ))}
// </select> */}
//       <div className="mb-4 d-flex flex-row justify-content-left align-items-center gap-1">
//         {" "}
//         <label className="form-label">Select Category:</label>
//         <div className="dropdown">
//           <a
//             className="btn btn-secondary dropdown-toggle p-2"
//             href="#"
//             variant="primary"
//             id="dropdown-basic"
//             role="button"
//             data-bs-toggle="dropdown"
//             aria-expanded="false"
//           >
//             {selectedCategory || "Select Category"}
//           </a>

//           <ul className="dropdown-menu">
//             {Object.keys(manualData).map((cat) => (
//               <li key={cat}>
//                 <a
//                   className="dropdown-item"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setIsDrilldown((prev) => !prev);
//                     setSelectedCategory(cat);
//                     setChartOptions(getChartOptions(cat));
//                   }}
//                 >
//                   {cat}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>

//       <div
//         className="position-relative d-flex justify-content-end "
//         style={{ marginBottom: "-40px", zIndex: "999999" }}
//       >
//         {/* Menu button */}

//         <button className="btn border p-2 " onClick={toggleDropdown}>
//           <FaBars size={20} />
//         </button>

//         {/* Dropdown Menu */}
//         {dropdownOpen && (
//           <div
//             className="position-absolute bg-white border rounded shadow p-2"
//             style={{
//               right: 0,
//               top: "110%",
//               minWidth: "180px",
//               zIndex: 10,
//             }}
//           >
//             <button className="dropdown-item p-2" onClick={captureScreenshot}>
//               Download
//             </button>
//             <button className="dropdown-item p-2" onClick={handleFullScreen}>
//               {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
//             </button>
//           </div>
//         )}
//       </div>

//       <div
//         ref={chartContainerRef}
//         className={`chart-container p-1 ${isFullScreen ? "fullscreen" : ""}`}
//       >
//         <HighchartsReact
//           key={isDrilldown}
//           highcharts={Highcharts}
//           options={chartOptions}
//         />
//       </div>
//     </div>
//   );
// };

// export default DrilldownChart;

import React, { useState, useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown";
import { FaBars } from "react-icons/fa";
import html2canvas from "html2canvas";
import "../App.css";

drilldown(Highcharts);

const newData = {
  data: {
    percentage_medicare: [
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Musculoskeletal System",
        Cigna: "186.94%",
        UHC: "222.86%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Digestive System",
        Cigna: "240.97%",
        UHC: "295.21%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Integumentary System",
        Cigna: "218.35%",
        UHC: "339.97%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Nervous System",
        Cigna: "197.67%",
        UHC: "271.49%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Cardiovascular System",
        Cigna: "283.53%",
        UHC: "291.42%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Urinary System",
        Cigna: "212.50%",
        UHC: "265.51%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Eye and Ocular Adnexa",
        Cigna: "207.00%",
        UHC: "284.05%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Female Genital System",
        Cigna: "240.61%",
        UHC: "264.53%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Respiratory System",
        Cigna: "239.08%",
        UHC: "284.04%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Male Genital System",
        Cigna: "179.66%",
        UHC: "282.99%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Auditory System",
        Cigna: "208.21%",
        UHC: "238.99%",
      },
      {
        Category: "Surgery",
        "Sub Category":
          "Surgical Procedures on the Hemic and Lymphatic Systems",
        Cigna: "220.36%",
        UHC: "268.79%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures for Maternity Care and Delivery",
        Cigna: "278.75%",
        UHC: "360.24%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Endocrine System",
        Cigna: "179.42%",
        UHC: "270.34%",
      },
      {
        Category: "Surgery",
        "Sub Category": "General Surgical Procedures",
        Cigna: "246.71%",
        UHC: "438.28%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Mediastinum and Diaphragm",
        Cigna: "Unavailable",
        UHC: "249.99%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Reproductive System Procedures",
        Cigna: "149.53%",
        UHC: "274.52%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Intersex Surgery",
        Cigna: "Unavailable",
        UHC: "403.97%",
      },
    ],
    percentage_discount: [
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Musculoskeletal System",
        Cigna: "69.90%",
        UHC: "64.11%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Digestive System",
        Cigna: "61.20%",
        UHC: "52.46%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Integumentary System",
        Cigna: "64.84%",
        UHC: "45.25%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Nervous System",
        Cigna: "68.17%",
        UHC: "56.28%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Cardiovascular System",
        Cigna: "54.34%",
        UHC: "53.07%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Urinary System",
        Cigna: "65.78%",
        UHC: "57.24%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Eye and Ocular Adnexa",
        Cigna: "66.67%",
        UHC: "54.26%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Female Genital System",
        Cigna: "61.25%",
        UHC: "57.40%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Respiratory System",
        Cigna: "61.50%",
        UHC: "54.26%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Male Genital System",
        Cigna: "71.07%",
        UHC: "54.43%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Auditory System",
        Cigna: "66.47%",
        UHC: "61.52%",
      },
      {
        Category: "Surgery",
        "Sub Category":
          "Surgical Procedures on the Hemic and Lymphatic Systems",
        Cigna: "64.52%",
        UHC: "56.72%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures for Maternity Care and Delivery",
        Cigna: "55.11%",
        UHC: "41.99%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Endocrine System",
        Cigna: "71.11%",
        UHC: "56.47%",
      },
      {
        Category: "Surgery",
        "Sub Category": "General Surgical Procedures",
        Cigna: "60.27%",
        UHC: "29.42%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Mediastinum and Diaphragm",
        Cigna: "Unavailable",
        UHC: "59.74%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Reproductive System Procedures",
        Cigna: "75.92%",
        UHC: "55.79%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Intersex Surgery",
        Cigna: "Unavailable",
        UHC: "34.95%",
      },
    ],
    percentage_completeness: [
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Musculoskeletal System",
        Cigna: "88.39%",
        UHC: "98.67%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Digestive System",
        Cigna: "80.29%",
        UHC: "98.89%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Integumentary System",
        Cigna: "92.25%",
        UHC: "98.68%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Nervous System",
        Cigna: "85.22%",
        UHC: "99.20%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Cardiovascular System",
        Cigna: "76.27%",
        UHC: "97.56%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Urinary System",
        Cigna: "71.05%",
        UHC: "97.46%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Eye and Ocular Adnexa",
        Cigna: "94.86%",
        UHC: "99.17%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Female Genital System",
        Cigna: "88.40%",
        UHC: "99.68%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Respiratory System",
        Cigna: "64.07%",
        UHC: "99.19%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Male Genital System",
        Cigna: "87.96%",
        UHC: "98.25%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Auditory System",
        Cigna: "59.18%",
        UHC: "87.71%",
      },
      {
        Category: "Surgery",
        "Sub Category":
          "Surgical Procedures on the Hemic and Lymphatic Systems",
        Cigna: "77.49%",
        UHC: "99.25%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures for Maternity Care and Delivery",
        Cigna: "75.58%",
        UHC: "100.00%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Endocrine System",
        Cigna: "90.37%",
        UHC: "100.00%",
      },
      {
        Category: "Surgery",
        "Sub Category": "General Surgical Procedures",
        Cigna: "100.00%",
        UHC: "100.00%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Surgical Procedures on the Mediastinum and Diaphragm",
        Cigna: "Unavailable",
        UHC: "100.00%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Reproductive System Procedures",
        Cigna: "100.00%",
        UHC: "100.00%",
      },
      {
        Category: "Surgery",
        "Sub Category": "Intersex Surgery",
        Cigna: "Unavailable",
        UHC: "100.00%",
      },
    ],
  },
};

// Transform the new data structure into the format expected by your chart
const transformData = (data) => {
  const result = {};

  // For each category in the data (we'll use percentage_medicare as the main dataset)
  data.data.percentage_medicare.forEach((item) => {
    const category = item.Category;
    const subCategory = item["Sub Category"];

    if (!result[category]) {
      result[category] = {};
    }

    result[category][subCategory] = {
      Cigna: parseFloat(item.Cigna) || "Unavailable",
      UHC: parseFloat(item.UHC) || "Unavailable",
    };
  });

  return result;
};

const manualData = transformData(newData);

const sortSubcategories = (categoryData) =>
  Object.fromEntries(Object.entries(categoryData).sort());

Object.keys(manualData).forEach((category) => {
  manualData[category] = sortSubcategories(manualData[category]);
});

const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];

const homeNetwork = "Cigna"; // Changed from "Anthem Participating Network" to "Cigna"

const DrilldownChart = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const chartContainerRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleFullScreen = () => {
    if (chartContainerRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        chartContainerRef.current.requestFullscreen().catch((err) => {
          console.error("Error attempting fullscreen:", err);
        });
      }
    }
  };

  const captureScreenshot = async () => {
    setDropdownOpen(false);

    const buttonElement = document.getElementById("capture-hide");
    if (buttonElement) {
      buttonElement.style.visibility = "hidden";
    }

    await new Promise((resolve) => setTimeout(resolve, 50));

    if (chartContainerRef.current) {
      await document.fonts.load('1em "Roboto Flex, serif !important"');
      const canvas = await html2canvas(chartContainerRef.current, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#FFFFFF",
        onclone: (clonedDoc) => {
          clonedDoc.body.style.fontFamily = "'Roboto Flex', serif !important";
        },
      });

      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "graph.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (buttonElement) {
      buttonElement.style.visibility = "visible";
    }
  };

  useEffect(() => {
    const checkFontLoaded = () => {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          // You can now safely capture the screenshot
        });
      }
    };

    window.onload = checkFontLoaded;

    return () => {
      window.onload = null;
    };
  }, []);

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullScreenChange);
  }, []);

  const [isDrilldown, setIsDrilldown] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("Surgery"); // Default to "Surgery" as it's the only category in new data

  const getChartOptions = (category, isDrilldownChart = true) => {
    const categoryData = manualData[category];
    const networks = ["Cigna", "UHC"]; // Simplified networks list

    const chartData = Object.entries(categoryData).map(([subcat, prices]) => ({
      name: subcat,
      y: typeof prices[homeNetwork] === "number" ? prices[homeNetwork] : null,
      drilldown: subcat,
      color: colorPalette[0],
    }));

    const drilldownSeries = Object.entries(categoryData).map(
      ([subcat, prices]) => ({
        name: subcat,
        id: subcat,
        data: networks.map((net, i) => [
          net,
          typeof prices[net] === "number" ? prices[net] : null,
        ]),
        colors: networks.map((net, i) =>
          net === homeNetwork
            ? colorPalette[0]
            : colorPalette[(i + 1) % colorPalette.length]
        ),
      })
    );

    return {
      chart: {
        type: "column",
        events: {
          load() {
            const chart = this;

            if (!chart.customChip) {
              chart.customChip = chart.renderer
                .label(
                  "Drill to Network Comparison",
                  chart.chartWidth - 230,
                  0,
                  "rect",
                  40,

                  40,
                  true
                )
                .attr({
                  fill: "#f0f0f0", // background color
                  padding: 10,
                  r: 4, // border radius
                  zIndex: 10,
                  width: 160,
                  stroke: "#ccc", // border color
                  "stroke-width": 0.5, // border thickness
                  display: "flex", // flexbox for centering
                  justifyContent: "center",
                  alignItems: "center",
                })
                .css({
                  color: "#333",
                  fontSize: "12px",
                  fontFamily: "'Roboto Flex', sans-serif",
                  textAlign: "center",
                  fontWeight: "500",
                })
                .add();
            }
          },
          drilldown() {
            const chart = this;
            if (chart.customChip) {
              chart.customChip.attr({
                text: "Drill to Subcategory",
                x: chart.chartWidth - 230,
                y: 0,
              });
            }
          },
          drillup() {
            const chart = this;
            if (chart.customChip) {
              chart.customChip.attr({
                text: "Drill to Network Comparison",
                x: chart.chartWidth - 230,
                y: 0,
              });
            }
          },
          redraw() {
            // Reposition chip on resize
            const chart = this;
            if (chart.customChip) {
              chart.customChip.attr({
                x: chart.chartWidth - 230,
                y: 0,
              });
            }
          },
        },
      },
      title: {
        text: category,
      },
      xAxis: {
        type: "category",
        labels: {
          rotation: 0, // Prevent rotation
          style: {
            fontFamily: "'Roboto Flex', serif !important",
            fontSize: "12px",
          },
        },
        useHTML: true,
        formatter: function () {
          // Save reference to current label
          return `<div class="xaxis-label" data-label="${this.value}">${this.value}</div>`;
        },
      },
      yAxis: {
        title: {
          text: "% of Medicare",
          style: {
            // color: "#555555",
            fontSize: "12px",
            fontFamily: "'Roboto Flex', serif !important",
            letterSpacing: "-0.75px",
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          states: {
            hover: {
              brightness: -0.4, // darken
            },
          },
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}",
            style: {
              color: "#555555",
              cursor: "pointer",
              border: "none",
              fontWeight: 500,
              fontSize: "12px",
              fontFamily: "'Roboto Flex', serif !important",
              textDecoration: "none",
            },
          },
        },
      },
      exporting: { enabled: false },
      tooltip: {
        headerFormat:
          '<span style="font-size: 14px; color: #5A5A5A; max-width: 250px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
          '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
        pointFormat:
          "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between' ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex; justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      series: [
        {
          name: category,
          colorByPoint: true,
          data: chartData,
        },
      ],
      drilldown: isDrilldownChart
        ? {
            series: drilldownSeries.map((series) => ({
              ...series,
              data: series.data.map(([net, value], i) => ({
                name: net,
                y: value,
                color: series.colors[i],
              })),
              states: {
                hover: {
                  enabled: false,
                  brightness: 0,
                },
              },
            })),
            activeAxisLabelStyle: {
              color: "#555555",
              cursor: "pointer",
              fontWeight: "normal",
              fontSize: "11px",
              fontFamily: "'Roboto Flex', serif !important",
              textDecoration: "none",
            },
            activeDataLabelStyle: {
              color: "#555555",
              cursor: "pointer",
              border: "none",
              fontWeight: 500,
              fontSize: "12px",
              fontFamily: "'Roboto Flex', serif !important",
              textDecoration: "none",
            },
            breadcrumbs: {
              position: {
                align: "left",
                fontFamily: "'Roboto Flex', serif !important",
              },
              buttonTheme: {
                fill: "#fff",
                stroke: "#ccc",
                style: {
                  color: "#333",
                },
              },
            },
            activeDataLabelStyle: {
              color: "#555555",
              cursor: "pointer",
              border: "none",
              fontWeight: 500,
              fontSize: "12px",
              fontFamily: "'Roboto Flex', serif !important",
              textDecoration: "none",
            },
            breadcrumbs: {
              position: {
                align: "left",
                fontFamily: "'Roboto Flex', serif !important",
              },
              buttonTheme: {
                fill: "#fff",
                stroke: "#ccc",
                style: {
                  color: "#333",
                },
              },
            },
          }
        : {},
    };
  };

  const [chartOptions, setChartOptions] = useState(
    getChartOptions(selectedCategory)
  );

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <div
        className="position-relative d-flex justify-content-between "
        style={{ marginBottom: "-40px", zIndex: "999999" }}
      >
        <div className="  d-flex flex-row justify-content-left align-items-center gap-1">
          <label className="form-label">Select Category:</label>
          <div className="dropdown">
            <a
              className="btn btn-secondary dropdown-toggle p-2"
              href="#"
              variant="primary"
              id="dropdown-basic"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedCategory || "Select Category"}
            </a>

            <ul className="dropdown-menu">
              {Object.keys(manualData).map((cat) => (
                <li key={cat}>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsDrilldown((prev) => !prev);
                      setSelectedCategory(cat);
                      setChartOptions(getChartOptions(cat));
                    }}
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          <button className="btn border p-2 " onClick={toggleDropdown}>
            <FaBars size={20} />
          </button>

          {dropdownOpen && (
            <div
              className="position-absolute bg-white border rounded shadow p-2"
              style={{
                right: 0,
                top: "110%",
                minWidth: "180px",
                zIndex: 10,
              }}
            >
              <button className="dropdown-item p-2" onClick={captureScreenshot}>
                Download
              </button>
              <button className="dropdown-item p-2" onClick={handleFullScreen}>
                {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        ref={chartContainerRef}
        className={`chart-container p-1 ${isFullScreen ? "fullscreen" : ""}`}
      >
        <HighchartsReact
          key={isDrilldown}
          highcharts={Highcharts}
          options={chartOptions}
        />
      </div>
    </div>
  );
};

export default DrilldownChart;
